import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { ButtonModule } from "@bfx/primeng/button";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DataTableModule } from "@bfx/primeng/datatable";
import { DropdownModule } from "@bfx/primeng/dropdown";
import { InputMaskModule } from "@bfx/primeng/inputmask";
import { InputTextModule } from "@bfx/primeng/inputtext";
import { RadioButtonModule } from "@bfx/primeng/radiobutton";
import { SpinnerModule } from "@bfx/primeng/spinner";
import { ToggleButtonModule } from "@bfx/primeng/togglebutton";
import { TooltipModule } from "@bfx/primeng/tooltip";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";

import { ATDLParserService } from "./services/atdl/atdl-parser.service";
import { ATDLUtilityService } from "./services/atdl/atdl-utility.service";
import { ATDLValidatorService } from "./services/atdl/atdl-validator.service";
import { ATDLComparatorService } from "./services/atdl/atdl-comparator.service";
import { ATDLDatasetService } from "./services/atdl/atdl-dataset.service";
import { ATDLProcessorService } from "./services/atdl/atdl-processor.service";

import { ICDRateSpinnerComponent } from "./interface/dynamic-controls/icd-rate-spinner.component";
import { ICDAutocompleteComponent } from "./interface/dynamic-controls/icd-autocomplete.component";
import { ICDUnsupportedComponent } from "./interface/dynamic-controls/icd-unsupported.component";
import { ICDTextFieldComponent } from "./interface/dynamic-controls/icd-text-field.component";
import { ICDAmountSpinnerComponent } from "./interface/dynamic-controls/icd-amount-spinner.component";
import { ICDPercentSpinnerComponent } from "./interface/dynamic-controls/icd-percent-spinner.component";
import { ICDIntegerSpinnerComponent } from "./interface/dynamic-controls/icd-integer-spinner.component";
import { ICDLabelComponent } from "./interface/dynamic-controls/icd-label.component";
import { ICDCheckboxComponent } from "./interface/dynamic-controls/icd-checkbox.component";
import { ICDClockComponent } from "./interface/dynamic-controls/icd-clock.component";
import { ICDCRadioButtonComponent } from "./interface/dynamic-controls/icd-radio-button.component";
import { BaseComponentsModule } from "../../shared/base-components/base-components.module";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    FormsModule,
    DataTableModule,
    InputTextModule,
    CheckboxModule,
    AutoCompleteModule,
    ButtonModule,
    ToggleButtonModule,
    SpinnerModule,
    DropdownModule,
    InputMaskModule,
    TooltipModule,
    RadioButtonModule,
    BfxElementsLibraryModule,
    BaseComponentsModule,
    BfxSharedModule,
  ],
  declarations: [
    ICDRateSpinnerComponent,
    ICDAutocompleteComponent,
    ICDUnsupportedComponent,
    ICDTextFieldComponent,
    ICDAmountSpinnerComponent,
    ICDPercentSpinnerComponent,
    ICDIntegerSpinnerComponent,
    ICDLabelComponent,
    ICDCheckboxComponent,
    ICDClockComponent,
    ICDCRadioButtonComponent,
  ],
  providers: [
    ATDLParserService,
    ATDLUtilityService,
    ATDLValidatorService,
    ATDLComparatorService,
    ATDLDatasetService,
    ATDLProcessorService,
  ],
  exports: [
    ICDRateSpinnerComponent,
    ICDAutocompleteComponent,
    ICDUnsupportedComponent,
    ICDTextFieldComponent,
    ICDAmountSpinnerComponent,
    ICDPercentSpinnerComponent,
    ICDIntegerSpinnerComponent,
    ICDLabelComponent,
    ICDCheckboxComponent,
    ICDClockComponent,
    ICDCRadioButtonComponent,
  ],
})
export class OEAlgoStrategyModule {}
